import { isLexicalEmpty } from './isLexicalEmpty.js';

export const getMissingRequiredArguments = ({ definitions = [], values = {} }) => {
  const requiredArgumentDefinitions = definitions.filter((arg) => arg.required && !arg.hidden && !arg.defaultValue);

  if (requiredArgumentDefinitions.length === 0) {
    // If there are no required arguments, return an empty array
    return requiredArgumentDefinitions;
  }

  return requiredArgumentDefinitions.filter((def) => {
    if (def.dataType === 'object' || def.dataType === 'array') {
      // A definition without a key cannot be a child path of `def`, so it's correctly excluded here.
      // Guarding against it also prevents one malformed arg (schema violation) from taking down the editor.
      const hasChildren = definitions.filter((n) => n.key?.startsWith(def.key) && n.key !== def.key)?.length;
      if (hasChildren) {
        // Skip if the argument is an object or array that has children (since we don't store values for object or array root in this case)
        return false;
      }
    }
    for (const [key, value] of Object.entries(values)) {
      // Loop through all the step values trying to find a match
      const parsedKey = key.replace(/\[\d+\]/g, '[]');
      if (parsedKey === def.key) {
        if (value?.type === 'lexical') {
          return isLexicalEmpty(value);
        }
        if (def.dataType === 'array') {
          // This is an array of primitives, check length
          if (Array.isArray(value)) {
            return value.length === 0;
          }
          return false;
        }
        return !value;
      }
    }
    // This means we couldn't find a match, so it's missing
    return true;
  });
};
